import {useLiveQuery} from "dexie-react-hooks";
import {db} from "@/app/storage";

export function useLibraryEntries(params?: {
  grouping?: string;
  type?: "vocab" | "character";
  languageCode?: string;
}) {
  return useLiveQuery(async () => {
    let collection = db.libraryEntries.where("isDeleted").equals(0);

    if (params?.grouping) {
      collection = collection.filter(e => e.grouping === params.grouping);
    }
    if (params?.type) {
      collection = collection.filter(e => e.type === params.type);
    }
    if (params?.languageCode) {
      collection = collection.filter(e => e.languageCode === params.languageCode);
    }

    return collection.toArray();
  }, [params?.grouping, params?.type, params?.languageCode]);
}

export function useLibraryEntry(uri: string) {
  return useLiveQuery(() => db.libraryEntries.get(uri), [uri]);
}
